<template>
  <div id="app">
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <router-link to="/" class="logo-link">
            <img :src="logo1" alt="泉州羊光网络科技有限公司" class="logo-image">
            <span class="logo-title">泉州羊光网络科技有限公司</span>
          </router-link>
        </div>
        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu" @click="toggleMenu">
          <el-icon :size="24"><Menu /></el-icon>
        </div>
        <!-- 导航菜单 -->
        <div class="nav-menu" :class="{ 'show': isMenuOpen }">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            router
            @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
            <el-menu-item index="/services">服务项目</el-menu-item>
            <el-menu-item index="/cases">成功案例</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </el-header>

    <router-view/>

    <el-footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>联系方式</h3>
          <p><el-icon><Phone /></el-icon> 电话：156-5950-2991</p>
          <p><el-icon><Message /></el-icon> 邮箱：1098826857@qq.com</p>
          <p><el-icon><Location /></el-icon> 地址：福建省泉州市</p>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/services">服务</router-link></li>
            <li><router-link to="/cases">案例</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>关注我们</h3>
          <div class="social-links">
            <a href="#"><el-icon><Share /></el-icon></a>
            <a href="#"><el-icon><ChatDotRound /></el-icon></a>
            <a href="#"><el-icon><Link /></el-icon></a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2024 Yangguang. All rights reserved.</p>
        <p><a target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2026023582号</a></p>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { Menu, Phone, Message, Location, Share, ChatDotRound, Link } from '@element-plus/icons-vue'
import logo1 from '@/assets/logo1.png'

export default {
  name: 'App',
  components: {
    Menu,
    Phone,
    Message,
    Location,
    Share,
    ChatDotRound,
    Link
  },
  data() {
    return {
      logo1,
      isMenuOpen: false,
      activeIndex: '/',
    }
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path
      this.isMenuOpen = false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    handleSelect(key) {
      this.activeIndex = key
      this.isMenuOpen = false
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 80px !important;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 80px;
}

.logo {
  flex-shrink: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.logo-image {
  height: 50px;
  width: auto;
}

.logo-title {
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
}

.nav-menu {
  display: flex;
  border: none !important;
}

.nav-menu .el-menu-item {
  font-size: 16px;
  padding: 0 20px;
}

.mobile-menu {
  display: none;
  cursor: pointer;
  color: #409EFF;
}
/* 隐藏子菜单 */
.el-sub-menu__hide-arrow{
  display: none;
}
.el-menu--popup {
    display: none !important;
}

.el-sub-menu__icon-arrow {
    display: none !important;
}

/* 移动端菜单样式 */
.el-menu--popup-container {
    display: none !important;
}

.el-menu--collapse {
    display: none !important;
}

.footer {
  margin-top: auto;
  background-color: #2c3e50;
  color: white;
  padding: 40px 0 20px;
  height: auto !important;
}
.footer a{
  text-decoration: none;
  color: white;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.footer-section {
  flex: 1;
  margin: 0 20px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #fff;
}

.footer-section p {
  margin: 10px 0;
  display: flex;
  align-items: center;
  color: #ccc;
}

.footer-section .el-icon {
  margin-right: 10px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin: 10px 0;
}

.footer-section ul li a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: #409EFF;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  color: #ccc;
  font-size: 20px;
  transition: color 0.3s;
}

.social-links a:hover {
  color: #409EFF;
}

.footer-bottom {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
  color: #ccc;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .header-content {
    height: 80px;
  }

  .logo-title {
    font-size: 16px;
  }

  .logo-image {
    
  }

  .mobile-menu {
    display: block;
  }

  .nav-menu {
    display: none;
    position: absolute;
    top: 7px;
    left: 0;
    right: 0;
    background-color: white;
    flex-direction: column;
  }

  .nav-menu.show {
    display: flex;
  }

  .nav-menu .el-menu-item {
    width: 100%;
    text-align: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-section {
    margin: 0 0 30px 0;
  }

  .footer-section p {
    justify-content: center;
  }

  .social-links {
    justify-content: center;
  }

  .footer-bottom {
    margin-top: 20px;
    padding-top: 15px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .header-content {
    padding: 0 15px;
  }

  .logo-link {
    gap: 8px;
  }

  .logo-title {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .logo-image {
    
  }

  .nav-menu .el-menu-item {
    font-size: 14px;
    padding: 12px 0;
  }

  .footer {
    padding: 30px 0 15px;
  }

  .footer-section h3 {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .footer-section p {
    font-size: 14px;
  }

  .footer-section ul li {
    font-size: 14px;
  }

  .social-links {
    gap: 10px;
  }

  .social-links a {
    font-size: 18px;
  }

  .footer-bottom {
    font-size: 12px;
  }
}
.el-sub-menu{
  position: relative;
  top: 10px;
}

/* 移动端菜单样式 */
.mobile-menu {
  display: none;
  cursor: pointer;
  color: #2c3e50;
}

@media (max-width: 768px) {
  .nav-menu {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    z-index: 1000;
  }

  .nav-menu.show {
    display: block;
  }

  .mobile-menu {
    display: block;
  }

  .el-menu {
    border: none;
  }

  .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
}
</style>
